import mascot from '../img/practikay-mascot.svg';
import heroImage from '../img/hero.png';
import appStoreBadge from '../img/Store=App Store, Type=Dark, Language=English@3x.png';
import googlePlayBadge from '../img/Store=Google Play, Type=Dark, Language=English@3x.png';
import SiteFooter from '../components/SiteFooter';

function HomeTopBar() {
  return (
    <div className="hero-topbar">
      <div className="hero-brand">
        <img className="gradient-mascot" src={mascot} alt="" aria-hidden="true" />
        <div className="hero-brand-text">
          <p className="hero-title">Pratikay</p>
        </div>
      </div>
      <p className="hero-subtitle hero-subtitle-right">Speak. More. Fluently.</p>
    </div>
  );
}

export default function HomeScreen() {
  return (
    <div className="app">
      <main id="main-content" tabIndex={-1}>
        <header className="hero">
          <div className="hero-inner">
            <img className="hero-image" src={heroImage} alt="" aria-hidden="true" />
            <div className="hero-topbar-overlay">
              <div className="content-well">
                <HomeTopBar />
              </div>
            </div>
            <div className="hero-message-overlay">
              <div className="content-well hero-message-stack">
                <div className="hero-message-well">
                <div className="hero-message-card">
                  <h1 className="hero-message-title">Practice your way to fluency</h1>
                  <p className="hero-message-subtitle">Speak more. Become fluent faster.</p>
                  <p className="hero-message-content">
                    Pratikay lets you practice your chosen language(s) through custom, real-time dialogs with partners. Hear pronunciation, see phonetics, and build confidence with every exchange so you can move from translating words to speaking naturally in real situations.
                  </p>
                    <div className="store-badges hero-download-badges">
                      <a href="https://apps.apple.com" aria-label="Download on the App Store">
                        <img src={appStoreBadge} alt="Download on the App Store" />
                      </a>
                      <a href="https://play.google.com/store" aria-label="Get it on Google Play">
                        <img src={googlePlayBadge} alt="Get it on Google Play" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        <section className="feature-section section-white">
        <div className="content-well feature-grid feature-grid-single">
          <article className="feature-copy feature-copy-wide">
            <h2>
              pra·ti·quer <span className="feature-origin">(French)</span>
            </h2>
            <h3><i>prah-tee-KAY</i></h3>
            <p className="feature-definition">
              <i>verb.</i> to practice; to engage in or carry out an activity regularly, especially to improve skill through repetition; to apply knowledge or techniques in a consistent, active, or habitual manner.
            </p>
          </article>
        </div>
      </section>

      <section className="feature-section section-blue">
        <div className="content-well feature-grid">
          <article className="feature-copy order-last">
            <h2>Use conversations to practice in real-time with a partner</h2>
            <p>Each dialog card stays in sync across devices so both speakers can follow the same turn-by-turn flow and focus on speaking, not setup.</p>
          </article>
          <div className="feature-image order-first">
            <img src="/media/simulator-1.png" alt="Conversation cards synced between partners in real time." />
          </div>
        </div>
      </section>

      <section className="feature-section section-white">
        <div className="content-well feature-grid">
          <article className="feature-copy">
            <h2>Create specific dialog for you and a partner to practice</h2>
            <p>Build custom scenarios for the moments you actually care about, then edit lines, speakers, and tone until the conversation feels natural.</p>
          </article>
          <div className="feature-image">
            <img src="/media/simulator-2.png" alt="Custom dialog editor with speaker turns and line-by-line setup." />
          </div>
        </div>
      </section>

      <section className="feature-section section-purple">
        <div className="content-well feature-grid">
          <article className="feature-copy order-last">
            <h2>Translate a single dialog conversation into multiple languages</h2>
            <p>Translate one conversation into your selected languages in a single pass, with each translated line mapped directly to the original dialog.</p>
          </article>
          <div className="feature-image order-first">
            <img src="/media/simulator-3.png" alt="One conversation translated into multiple selected languages." />
          </div>
        </div>
      </section>

      <section className="feature-section section-silver">
        <div className="content-well feature-grid">
          <article className="feature-copy">
            <h2>Easily find and start a conversation with a partner or persona</h2>
            <p>Practice with friends, personas, or AI-assisted replies so you can keep building speaking reps even when a live partner is unavailable.</p>
          </article>
          <div className="feature-image">
            <img src="/media/simulator-4.png" alt="Conversation list showing quick access to partner and persona dialogs." />
          </div>
        </div>
      </section>

      <section className="feature-section section-orange">
        <div className="content-well feature-grid">
          <article className="feature-copy order-last">
            <h2>Choose your preferred languages for translating</h2>
            <p>Pick the languages you want to train and switch them anytime, so every new dialog is generated for the exact mix you are studying.</p>
          </article>
          <div className="feature-image order-first">
            <img src="/media/simulator-5.png" alt="Language selection screen for choosing translation targets." />
          </div>
        </div>
      </section>

      <section className="feature-section section-white">
        <div className="content-well feature-grid">
          <article className="feature-copy">
            <h2>Personalize the app by choosing a color theme and dark mode preference</h2>
            <p>Customize theme colors and display style to match your preference, making long practice sessions easier on your eyes and attention.</p>
          </article>
          <div className="feature-image">
            <img src="/media/simulator-6.png" alt="Theme settings with color and light or dark mode options." />
          </div>
        </div>
      </section>

      <section className="feature-section section-green">
        <div className="content-well feature-grid">
          <article className="feature-copy order-last">
            <h2>Create your profile and keep your data synced</h2>
            <p>Set your username, choose your voice preference, and link Apple or Google so your conversations, settings, and progress persist across sessions and devices.</p>
          </article>
          <div className="feature-image order-first">
            <img src="/media/simulator-7.png" alt="Profile setup with username, voice preference, and sign-in options." />
          </div>
        </div>
      </section>

      <section className="feature-section section-white">
        <div className="content-well feature-grid">
          <article className="feature-copy">
            <h2>Add partners or build personas for solo practice</h2>
            <p>Invite real partners for live conversation practice, or create custom personas to keep training on your own whenever a partner is not available.</p>
          </article>
          <div className="feature-image">
            <img src="/media/simulator-8.png" alt="Partners and personas screen for inviting people or creating personas." />
          </div>
        </div>
      </section>

      <section className="feature-section section-pink">
        <div className="content-well feature-grid">
          <article className="feature-copy order-last">
            <h2>Choose a plan or purchase additional top-off packs that matches your practice pace</h2>
            <p>You can stay on the free plan, add one-time top-off packs as needed, or choose a subscription for recurring credits, with clear limits for dialog length and number of translation languages.</p>
          </article>
          <div className="feature-image order-first">
            <img src="/media/simulator-9.png" alt="Plans and packs screen with free, subscription, and top-off options." />
          </div>
        </div>
      </section>

      <section className="feature-section section-white">
        <div className="content-well feature-grid">
          <article className="feature-copy">
            <h2>Track credits, purchases, and conversation completion history</h2>
            <p>Track usage history, conversation completions, and plan credits so you always know where your practice is going and what to work on next.</p>
          </article>
          <div className="feature-image">
            <img src="/media/simulator-10.png" alt="Activity and usage overview with credits and completion tracking." />
          </div>
        </div>
      </section>

        <section className="feature-section section-teal" style={{ display: 'none' }}>
        <div className="content-well feature-grid">
          <article className="feature-copy order-last">
            <h2>Feature Section 12</h2>
            <p>Manage privacy, terms, and account controls in-app, including plain-language legal summaries, partner permission flows, and deactivation options.</p>
          </article>
          <div className="feature-image order-first">
            <div className="image-placeholder">Image Placeholder</div>
          </div>
        </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}
